type Args = { accountId: number };

class FetchRetentionSettings {
	readonly accountId: number;

	constructor(args: Args) {
		this.accountId = args.accountId;

		Object.freeze(this);
	}
}

export default FetchRetentionSettings;
